import apiSportsEvent from '@/api/sports-events'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
}

export const mutationTypes = {
  getSportsEventsTrainersListStart:
    '[sportsEvents trainers list] Get sportsEvents trainers start',
  getSportsEventsTrainersListSuccess:
    '[sportsEvents trainers list] Get sportsEvents trainers success',
  getSportsEventsTrainersListFailure:
    '[sportsEvents trainers list] Get sportsEvents trainers failure',
}

export const actionTypes = {
  getSportsEventsTrainersList:
    '[sportsEvents trainers list] Get sportsEvents trainers list',
}

const mutations = {
  [mutationTypes.getSportsEventsTrainersListStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getSportsEventsTrainersListSuccess](state, payload) {
    state.total = payload.total
    state.data = payload.data ? payload.data : payload.list
    state.isLoading = false
  },

  [mutationTypes.getSportsEventsTrainersListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getSportsEventsTrainersList](context, params) {
    context.commit(mutationTypes.getSportsEventsTrainersListStart)
    return new Promise((resolve) => {
      apiSportsEvent
        .getSportsEventsTrainersList(params)
        .then((response) => {
          context.commit(mutationTypes.getSportsEventsTrainersListSuccess, {
            ...response.data,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(
            mutationTypes.getSportsEventsTrainersListFailure,
            error
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
